import { ChangeDetectionStrategy, Component, HostBinding } from "@angular/core";

@Component({
    selector: "sps-workflow-document, sps-wf-doc",
    template: `<ng-content></ng-content>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsWorkflowDocumentComponent {
    static readonly displayName = "sps-workflow-document, sps-wf-doc";
    static readonly props = {};

    @HostBinding("class.sps-workflow__document") _spsWorkflowDocumentClass = true;
}
